import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChatComponent } from './components/chat/chat.component';
import { AppComponent } from './app.component';
import { ChatGuard } from './guards/chat-guard/chat.guard';


const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  //
  { path: 'chat'             , component: ChatComponent, canActivate: [ChatGuard] },
  { path: 'home'             , component: AppComponent  },
  //
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
